import React from 'react';

import Grupos from '../selectGrupos/index';

export function GruposVeiculos() {
  return <Grupos />;
}

